/*eslint react-hooks/exhaustive-deps:off*/
import React, { useEffect, useState, Suspense, lazy, useRef } from 'react';
import bannerPresentationService from '@services/bannerAndPresentation';
import { useSelector, useDispatch } from 'react-redux';
import analyticService from '@root/src/services/analytic.service';
import dataCodeService from '@root/src/services/dataCode.service';
import settingService from '@services/setting.service';
import PageNotFound from '../errorPages/pageErreur404';
import socketIOClient from 'socket.io-client';
import LoadingPage from '@components/Loading/LoadingPage';
import jobService from '@services/job.service';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import StandardNotification from '@components/warnings/standardNotification';
import 'react-toastify/dist/ReactToastify.css';
import { ERROR } from '@utils/constants';
import { isSomePropertiesNotNullable } from '@utils/_function';
import faqService from '@services/faq.service';
import TestimonyService from '@root/src/services/Testimony.service';

const JOB_EVENT = 'reload_job';
const ENDPOINT =
  process.env.REACT_APP_WS_SERVER_URI || process.env.REACT_APP_SERVER_URI;
const Footer = lazy(() => import('./Footer'));
const InfoPresentation = lazy(() => import('./infoPresentation'));
const Menu = lazy(() => import('./Menu'));
const Header = lazy(() => import('./header'));
const initialSocket = socketIOClient(ENDPOINT, {
  transports: ['websocket', 'polling', 'flashsocket'],
});

const Layout = ({ children }) => {
  const enterpriseIdentifiant = useSelector(
    (state) => state.enterpriseIdentifiant,
  );
  const isLoadingIdentifiant = useSelector(
    (state) => state.isLoadingIdentifiant,
  );
  const [settings, setSettings] = useState({});
  const [onLoad, setOnLoad] = useState(true);
  const [bannerPresentation, setBannerPresentation] = useState({});
  const [trackingID, setTrackingID] = useState('');
  const [facebookPixelID, setFacebookPixelID] = useState('');
  const [dataSEOCode, setDataSEOCode] = useState({});
  const [jobDeleted, setJobDeleted] = useState(false);
  const { id } = useParams();
  const idRef = useRef(id);
  const dispatch = useDispatch();
  let standardNotification = useSelector((state) => state.standardNotification);
  const [faqs, setFaqs] = useState([]);
  const [testimony, setTestomony] = useState(null);

  useEffect(() => {
    faqService
      .getByIdentifiant(enterpriseIdentifiant)
      .then((faqs) => {
        if (faqs !== 'NOT FOUND') setFaqs(faqs);
      })
      .catch((err) => {
        console.error('Error get faq by enterprise: ', err);
      });
    TestimonyService.getExtraitByIdentifiant(enterpriseIdentifiant).then(
      (testimonies) => {
        if (testimonies !== 'NOT FOUND') setTestomony(testimonies);
      },
    );
  }, [enterpriseIdentifiant]);

  const toastStandardNotification = (message, type) => {
    toast.info(
      <StandardNotification type={type} message={message} withBorder={false} />,
      {
        hideProgressBar: false,
        autoClose: 2000,
        draggable: false,
      },
    );
  };

  const reloadFindedJob = async (idJob) => {
    await jobService
      .findById(idJob)
      .then((response) => {
        setJobDeleted(false);
      })
      .catch((err) => {
        console.error('Error get job by enterprise:', err);
        setJobDeleted(true);
      });
  };
  useEffect(() => {
    idRef.current = id;
    if (id) reloadFindedJob(id);
  }, [id]);

  useEffect(() => {
    if (standardNotification?.length) {
      let notificationData =
        standardNotification?.[standardNotification?.length - 1];
      toastStandardNotification(
        notificationData?.message,
        notificationData?.type,
      );
    }
  }, [standardNotification]);
  useEffect(() => {
    bannerPresentationService
      .getByIdentifiant(enterpriseIdentifiant)
      .then((bannerPresentation) => {
        if (bannerPresentation !== 'NOT FOUND') {
          setBannerPresentation(bannerPresentation);
          let favicon = document.getElementById('favicon');
          if (favicon && bannerPresentation.favIcon) {
            favicon.href = bannerPresentation.favIcon;
          }
        }
      })
      .catch((err) => {
        console.error('Error get faq by enterprise: ', err);
      });

    analyticService
      .getByIdentifiant(enterpriseIdentifiant)
      .then((analytics) => {
        if (analytics !== 'NOT FOUND') {
          setTrackingID(analytics.googleAnalyticsID);
          setFacebookPixelID(analytics.facebookPixelID);
        }
      })
      .catch((err) => {
        console.error('Error get analytics by enterprise: ', err);
      });

    dataCodeService
      .getByIdentifiant(enterpriseIdentifiant)
      .then((dataCodes) => {
        if (dataCodes !== 'NOT FOUND') {
          setDataSEOCode(dataCodes);
        }
      })
      .catch((err) => {
        console.error('Error get dataCodes by enterprise: ', err);
      });
    if (enterpriseIdentifiant) getSetting();
  }, [enterpriseIdentifiant]);

  const getSetting = () => {
    setOnLoad(true);
    settingService
      .getByIdentifiant(enterpriseIdentifiant)
      .then((responses) => {
        setSettings(responses);
        localStorage.setItem(
          'enterpriseName',
          JSON.stringify(responses.entreprise.enterpriseName),
        );
        localStorage.setItem('settingsEnterprise', JSON.stringify(responses));
        dispatch({
          type: 'SET_SETTING',
          payload: responses,
        });
        localStorage.removeItem('refresh-attempt');
        setOnLoad(false);
      })
      .catch((err) => {
        console.error('Error get settings by enterprise: ', err);
        if (err.message === 'Network Error') {
          let refreshAttempt = localStorage.getItem('refresh-attempt');

          if (refreshAttempt === null || isNaN(+refreshAttempt)) {
            refreshAttempt = 2;
          } else {
            refreshAttempt = +refreshAttempt;
          }

          if (refreshAttempt > 0) {
            localStorage.setItem('refresh-attempt', `${refreshAttempt - 1}`);
            window.location.reload();
            return;
          }
        }
        setOnLoad(false);
      });
  };

  useEffect(() => {
    initialSocket.on('reload_setting', async () => {
      getSetting();
      loadRootColor();
    });
    initialSocket.on(JOB_EVENT, async (job) => {
      if (idRef.current) reloadFindedJob(idRef.current);
    });
    //loadRootColor();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    loadRootColor();
    // eslint-disable-next-line
  }, [settings]);

  const loadRootColor = () => {
    let ColorBorderMenu = '#ff7c44';
    let firstColor = '#fcb698';
    let secondColor = '#fa966b';
    let baseColor02 = '#FFF4EF';
    if (settings?.customColor?.valueHexadecimale) {
      ColorBorderMenu = settings?.customColor?.rgba1;
      baseColor02 = settings?.customColor?.rgba02;
      firstColor = settings?.customColor?.rgba05;
      secondColor = settings?.customColor?.rgba08;
    }
    let rootColor = document.createElement('style');
    rootColor.innerText = `
      :root {
        --ColorBorderMenu: ${ColorBorderMenu};
        --firstColor: ${firstColor};
        --secondColor: ${secondColor};
        --baseColor02: ${baseColor02};
        --whiteColor: #ffffff;
        --darkColor: #292929;
        --fontColor: #5a5a5a;
        --greyColor: #f9fafc;
        --fityDark: rgba(0, 0, 0, 0.5);
        --borderColor: rgba(216, 216, 216, 0.5);
        --blueColor: #7da6d1;
        --greenColor: #73c7b7;
        --greenFontColor: #488b7e;
        --firstBackground: #e5e5e5;
      }
    `;

    document.getElementsByTagName('head')[0].appendChild(rootColor);
  };

  const loadGoogleAnalytics = (trackingID) => {
    let gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute(
      'src',
      `https://www.googletagmanager.com/gtag/js?id=${trackingID}`,
    );

    let gaScript2 = document.createElement('script');
    // eslint-disable-next-line
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

    document.getElementsByTagName('head')[0].appendChild(gaScript);
    document.getElementsByTagName('head')[0].appendChild(gaScript2);
  };

  const loadFacebookPixel = (facebookPixelID) => {
    let fbPixelScript = document.createElement('script');
    fbPixelScript.innerText = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '${facebookPixelID}');fbq('track', 'PageView');`;

    document.getElementsByTagName('head')[0].appendChild(fbPixelScript);
  };

  const loadDataCodes = (dataCode) => {
    if (dataCode.headCode !== undefined) {
      for (let i = 0; i < stringToHTML(dataCode.headCode).length; i++) {
        document.head.appendChild(stringToHTML(dataCode.headCode)[i]);
      }
    }

    if (dataCode.footerCode !== undefined) {
      for (let i = 0; i < stringToHTML(dataCode.footerCode).length; i++) {
        document.body.append(stringToHTML(dataCode.footerCode)[i]);
      }
    }
  };

  const stringToHTML = (str) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.head.children;
  };

  useEffect(() => {
    if (trackingID !== '') {
      loadGoogleAnalytics(trackingID);
    }
  }, [trackingID]);

  useEffect(() => {
    if (facebookPixelID !== '') {
      loadFacebookPixel(facebookPixelID);
    }
  }, [facebookPixelID]);

  useEffect(() => {
    loadDataCodes(dataSEOCode);
    // eslint-disable-next-line
  }, [dataSEOCode]);

  const havePresentation =
    isSomePropertiesNotNullable(bannerPresentation, [
      'presentation',
      'mission',
      'search',
    ]) ||
    testimony ||
    faqs?.length > 0;

  if (onLoad || isLoadingIdentifiant) {
    return <LoadingPage settings={settings} />;
  } else if (id && jobDeleted) {
    return <PageNotFound />;
  } else if (settings?._id) {
    return (
      <div className="jobAltee_content">
        <div className="header_jobAltee">
          {standardNotification?.[standardNotification?.length - 1]?.message ? (
            <div
              className={
                standardNotification?.[standardNotification?.length - 1]
                  ?.type === ERROR
                  ? 'calloutMessage--error'
                  : 'calloutMessage--success'
              }
            >
              <div className="notification_mobile">
                <ToastContainer pauseOnHover />
              </div>
              <div className="notification_desktop">
                <ToastContainer pauseOnHover />
              </div>
            </div>
          ) : (
            ''
          )}

          <Suspense>
            <Header bannerPresentation={bannerPresentation} />
            <Menu />
          </Suspense>
        </div>
        <div className="pagination_jobAltee">
          <div className="main_pagination" style={{ position: 'relative' }}>
            <Suspense
              fallback={
                <LoadingPage settings={settings} style={{ top: '10%' }} />
              }
            >
              {children}
            </Suspense>
          </div>
          {havePresentation ? (
            <div className="Infopages_jobAltee">
              <Suspense
                fallback={
                  <LoadingPage settings={settings} style={{ top: '10%' }} />
                }
              >
                <InfoPresentation bannerPresentation={bannerPresentation} />
              </Suspense>
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="footer_jobAltee cs-mt-5">
          <Suspense>
            <Footer />
          </Suspense>
        </div>
      </div>
    );
  } else {
    return <PageNotFound />;
  }
};

export default Layout;
